import template from './share-amount.jade';
import validation from '../../../services/validation';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular.module('cian.addForm.commonShareAmount', []).directive('cianAfCommonShareAmount', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    'deviceService',
    'store',
    function (deviceService, store) {
      this.isMobile = deviceService.isMobile;
      this.validation = validation(this.form, 'shareAmount', {
        parse: 'Введите одно из значений по примеру: 25%, 0.25 или 1/4',
        required: 'Введите значение',
        max: 'Доля должна быть меньше 1(100%)',
        min: 'Значение не может быть меньше или равно 0',
      });

      let trackedValue;

      this.handleBlur = () => {
        const value = this.ad.shareAmount;

        if (value && value !== trackedValue) {
          const state = store.getState();
          const category = selectAnalyticsOfferStatus(state);

          trackRequiredFieldFill(category, 'share_value');
          trackedValue = value;
        }
      };
    },
  ],
  controllerAs: 'shareAmount',
  template,
})).name;
